import { InfoCircleOutlined } from '@ant-design/icons';

import styles from '../styles/StoreStatus.module.css';

export const storeStatus = (status, statusText) => {
  const className = {
    'abierta': styles.storeOpen,
    'cerrado': styles.storeClosed,
    'cierre temporal': styles.storeTempClosed,
  };
  return (
    <p className={status in className ? className[status] : className.abierta}>
      <InfoCircleOutlined />
      {statusText}
    </p>
  );
};

export const initNominatimClient = (setterFunction) => {
  try {
    import('nominatim-client').then((mod) => {
      const provider = mod.default.createClient({ secure: true });
      setterFunction(provider);
    });
  } catch (e) {
    console.error(e);
  }
};
